<script lang="ts">
  interface Props {
    direction?: "up" | "down";
  }

  let { direction = "down" }: Props = $props();
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
  class:rotate-180={direction === "up"}>
  <mask
    id="mask0_7377_4202"
    style="mask-type:alpha"
    maskUnits="userSpaceOnUse"
    x="0"
    y="0"
    width="20"
    height="20">
    <rect width="20" height="20" fill="#D9D9D9" />
  </mask>
  <g mask="url(#mask0_7377_4202)">
    <path
      d="M9.60482 11.6042L6.64401 8.64179C6.60316 8.60095 6.57253 8.55668 6.55211 8.509C6.53169 8.46133 6.52148 8.41319 6.52148 8.36458C6.52148 8.26736 6.55586 8.18229 6.62461 8.10938C6.69336 8.03646 6.78398 8 6.89648 8H13.1048C13.2173 8 13.3079 8.0375 13.3767 8.1125C13.4454 8.1875 13.4798 8.275 13.4798 8.375C13.4798 8.38889 13.439 8.47758 13.3573 8.64106L10.3965 11.6042C10.3409 11.6597 10.2784 11.7014 10.209 11.7292C10.1395 11.7569 10.0701 11.7708 10.0007 11.7708C9.93121 11.7708 9.86176 11.7569 9.79232 11.7292C9.72287 11.7014 9.66037 11.6597 9.60482 11.6042Z"
      fill="#FAFAFA" />
  </g>
</svg>
